module.exports = __webpack_public_path__ + "canny-clickup-integration-1414f9423b8cbb54d8067bccd33fa62d.png";